import { api } from "../api";

/**
 * createInterestPointCrudRequest - Function that creates a new interest point
 * /interest-points
 * method POST
 * @async-function
 */
const createInterestPointCrudRequest = async (
    token: string,
    data: any
) => {
    const response = await api.post(
        `/interest-points`,
        data,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response;
};

export default createInterestPointCrudRequest;
